import React from 'react';
import styled from 'styled-components';

interface TaskOverviewCardProps {
    items: Array<{
        label: string;
        value: React.ReactNode;
        key?: string;
    }>;
    className?: string;
    columns?: number;
}

const OverviewGrid = styled.div<{ columns: number }>`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;

    @media (min-width: 768px) {
        grid-template-columns: repeat(${(props) => props.columns}, 1fr);
    }
`;

const OverviewItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;

    label {
        font-size: 11px;
        color: #666;
        text-transform: uppercase;
        font-weight: ${(props) => props.theme.font.medium};
    }

    .value {
        font-size: 14px;
        font-weight: ${(props) => props.theme.font.medium};
        color: ${(props) => props.theme.app.textColor};
    }
`;

/**
 * TaskOverviewCard - Atomic component for displaying task overview information
 * Displays key-value pairs in a responsive grid layout
 */
export const TaskOverviewCard: React.FC<TaskOverviewCardProps> = ({ items, className, columns = 3 }) => {
    return (
        <OverviewGrid columns={columns} className={className}>
            {items.map((item, index) => (
                <OverviewItem key={item.key || index}>
                    <label>{item.label}</label>
                    <div className='value'>{item.value}</div>
                </OverviewItem>
            ))}
        </OverviewGrid>
    );
};

export default TaskOverviewCard;
